import { createRoot } from 'react-dom/client'
import { StrictMode } from 'react'
import { App } from './App'
import data from 'public/data/page-data.yml'

const pageData = window.__PAGE_DATA__ || data

const container = document.getElementById('app')!
const root = createRoot(container)

root.render(
  <StrictMode>
    <App data={pageData} />
  </StrictMode>
)
